import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

/**
 * Generated class for the ToolCardComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "tool-card",
  templateUrl: "tool-card.html",
})
export class ToolCardComponent {
  @Input() assessmentId: string;
  @Input() sectionId: string;
  @Input() config;
  @Input() disabled: boolean = false;
  @Output() onDataUpdate: EventEmitter<any> = new EventEmitter();
  @Output() onCardInitialized: EventEmitter<any> = new EventEmitter();

  @ViewChild("buttonContainer") buttons;

  id: string;
  componentId: string;
  label: string;
  declinable: boolean;

  tools: string[] = [];
  currentTool: string;
  values: object = {};
  scrollRate: number = 25; // Percent of tool bar to scroll on click
  scrollAmount: number;
  readonly: boolean = false;

  initialized: boolean = false;

  constructor(public translatePipe: TranslateService) {}

  ngOnInit(): void {
    // console.log( "Incoming configuration for question card: ", this.config );

    this.id = this.config.id;
    this.componentId = this.config.componentId;
    this.label =
      this.config.label !== undefined
        ? this.config.label
        : this.config.cardName;
    this.tools = this.config.tools;
    this.declinable = this.config.declinable;
    this.readonly = this.config.readonly;
  }

  ngAfterContentInit(): void {
    if (this.tools.length) {
      this.scrollRate = 100 / this.tools.length;
    }
    this.scrollAmount =
      this.buttons.nativeElement.scrollWidth * (this.scrollRate / 100);
  }

  @Input() set data(incomingData: any) {
    // console.log( "Tool card Data: ", this.data );
    // console.log( "Tool card Incoming data: ", incomingData );
    if (incomingData) {
      // console.log( "Loaded data for tool card: ", incomingData );

      let cardData = incomingData;
      if (cardData.data) {
        this.values = cardData.data[0];
      }
    }

    if (incomingData !== undefined && !this.initialized) {
      // console.log( "Flagging tool card as initialized.", this.id );
      this.initialized = true;
      this.onCardInitialized.emit(this.id);
    }
  }

  toolSelected(tool: string) {
    // console.log("Tool selected:", tool);
    this.currentTool = tool;
  }

  dataUpdate(data: object) {
    // console.log("Tool data update: ", this.currentTool, data);

    this.values[this.currentTool] = data;
    this.onDataUpdate.emit({ cardId: this.id, value: this.values });
  }

  scrollLeft() {
    this.buttons.nativeElement.scrollLeft -= this.scrollAmount;
  }

  scrollRight() {
    this.buttons.nativeElement.scrollLeft += this.scrollAmount;
  }

  getHeaderValue(tool, val): string {
    if (tool == "pps") {
      if (val["pps"] !== undefined && val["pps"] !== null) {
        if (
          val["pps"]["assessorScore"] != undefined &&
          val["pps"]["assessorScore"] != null &&
          val["pps"]["assessorScore"] != ""
        ) {
          return (
            this.translatePipe.instant(tool) +
            " ( " +
            val["pps"]["assessorScore"] +
            " ) "
          );
        } else {
          return this.translatePipe.instant(tool);
        }
      } else {
        return this.translatePipe.instant(tool);
      }
    } else if (tool == "fast") {
      if (val["fast"] !== undefined && val["fast"] !== null) {
        if (
          val["fast"].value != undefined &&
          val["fast"].value != null &&
          val["fast"].value != ""
        ) {
          return (
            this.translatePipe.instant(tool) + " ( " + val["fast"].value + " ) "
          );
        } else {
          return this.translatePipe.instant(tool);
        }
      } else {
        return this.translatePipe.instant(tool);
      }
    } else if (tool == "mmse") {
      if (val["mmse"] !== undefined && val["mmse"] !== null) {
        if (
          val["mmse"].score != undefined &&
          val["mmse"].score != null &&
          val["mmse"].score != ""
        ) {
          return (
            this.translatePipe.instant(tool) + " ( " + val["mmse"].score + " ) "
          );
        } else {
          return this.translatePipe.instant(tool);
        }
      } else {
        return this.translatePipe.instant(tool);
      }
    } else if (tool == "nyha") {
      if (val["nyha"] !== undefined && val["nyha"] !== null) {
        if (
          val["nyha"].value != undefined &&
          val["nyha"].value != null &&
          val["nyha"].value != ""
        ) {
          return (
            this.translatePipe.instant(tool) +
            " ( " +
            this.translatePipe.instant(val["nyha"].value) +
            " ) "
          );
        } else {
          return this.translatePipe.instant(tool);
        }
      } else {
        return this.translatePipe.instant(tool);
      }
    } else if (tool == "karnofsky") {
      if (val["karnofsky"] !== undefined && val["karnofsky"] !== null) {
        if (
          val["karnofsky"].value != undefined &&
          val["karnofsky"].value != null &&
          val["karnofsky"].value != ""
        ) {
          return (
            this.translatePipe.instant(tool) +
            " ( " +
            val["karnofsky"].value +
            " ) "
          );
        } else {
          return this.translatePipe.instant(tool);
        }
      } else {
        return this.translatePipe.instant(tool);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/tools/tool-card/tool-card.ts